import styled from 'styled-components';

import { Grid, Button, Pagination, Paper } from '@mui/material';

export const PaperContainer = styled(Paper)`
    display: flex;
    flex-direction: column;
    align-items: ${({ center }) => (center ? 'center' : 'flex-start')};
    /* justify-content: ${({ justify }) => justify ?? 'space-evenly'}; */
    padding: 24px;
    gap: 15px;
    width: 100%;
    height: ${({ height }) => height ?? '140px'};

    box-shadow: 0px 3px 12px rgba(81, 69, 159, 0.08);
    border-radius: 15px;
`;

export const ExcelButton = styled(Button)`
    width: 154px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-self: flex-end;
    justify-content: space-between;
    padding: 0px 16px;
    text-transform: capitalize;
    background: #3a6647;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
`;

export const TableStyled = styled(Grid)`
    border: 1px solid #cdd2d9;
    border-radius: 8px;
`;

export const HeaderRow = styled(Grid)`
    font-weight: bold;
    font-size: 16px;
    background-color: #f0f1f3;
    border-radius: 8px 8px 0px 0px;
    padding: 10px;
`;

export const HeaderCell = styled(Grid)`
    text-align: ${({ align }) => align || 'center'};
`;

export const BodyRow = styled(Grid)`
    border-radius: 8px;
`;
export const BodyCell = styled(Grid)`
    padding: 2px 10px;
    border-top: 1px solid #cdd2d9;
    text-align: ${({ align }) => align || 'center'};
`;

export const StyledPagination = styled(Pagination)`
    & .MuiPaginationItem-root {
        borderColor: '#3A6647';

        &.Mui-selected {
            backgroundColor: 'white',
            borderColor: '#3A6647',
            color: '#3A6647',
        }
        &.MuiPaginationItem-icon {
            color: '#3A6647'
        }
    }
`;
